<script>
import {getSettingItem, setSystemSettingInfo} from "@/api/setting-api";

export default {
  name: "LanguageEmployeeSettingView",
  data() {
    return {
      target: "LANGUAGE_EN",
      type: "EMPLOYEE_FIELD",

      visitorConfig: [
        {key: "name", label: "员工姓名", label_en: "Employee Name"},
        {key: "loginName", label: "登录账号", label_en: "Login Account"},
        {key: "tel", label: "员工电话", label_en: "Mobile Number"},
        {key: "departmentName", label: "员工部门", label_en: "Employee Department"},
        {key: "email", label: "员工邮箱", label_en: "Email"},
        {key: "workId", label: "员工工号", label_en: "WorkId"},
      ],
    }
  },
  mounted() {
    this.setupPage()
  },

  methods: {
    setupPage() {
      getSettingItem(this.target, this.type).then(({data}) => {
        console.log("getSettingItem", data)
        if (data.code === 200 && data.data.length > 0) {
          let setting = data.data[0]
          let content = JSON.parse(setting.content)

          this.visitorConfig.forEach((item) => {
            let find = content.find((config) => config.key === item.key)
            if (find) {
              item.label_en = find.label_en
            }
          })

        }
      }).catch((err) => {
        console.log("getSettingItem err", err)
      })
    },




    saveAreaSetting() {
      let content = JSON.stringify(this.visitorConfig)
      let setting = {target: this.target, type: this.type, content: content, state: "VALID"}
      setSystemSettingInfo(setting).then(({data}) => {
        console.log("setSystemSettingInfo", data)
        if (data.code === 200) {
          this.$message.success("保存成功")
        } else {
          this.$message.error("保存失败")
        }
      }).catch((err) => {
        console.log("setSystemSettingInfo err", err)
      })
    },


  }, // methods
}
</script>

<template>
  <div>
    <el-table :data="visitorConfig" stripe border >
      <el-table-column prop="key" label="字段名称"></el-table-column>
      <el-table-column prop="label" label="中文内容"></el-table-column>
      <el-table-column label="英文内容">
        <template slot-scope="scope">
          <el-input v-model="scope.row.label_en" ></el-input>
        </template>
      </el-table-column>
    </el-table>
    <div class="p-4 text-center" style="width: 80%">
      <el-button class="w-40"  type="primary" @click="saveAreaSetting">保存</el-button>
    </div>


  </div>
</template>

<style scoped lang="less">

</style>
